// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smv-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  min-width: 0;
}

.smv-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.smv-form__label {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  line-height: 1.3;
}

.smv-form__req {
  color: #ef4444;
  font-weight: 600;
}

.smv-form__static {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 14px;
  line-height: 1.4;
}

.smv-form__hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
}

.smv-form__hint.is-error {
  color: #e11d48;
}

.smv-form .ant-form-item-label,
.smv-form .ant-form-item-feedback-icon {
  display: none !important;
}

.smv-form .ant-form-item,
.smv-form .ant-form-item-control-input,
.smv-form .ant-form-item-control-input-content {
  width: 100%;
  min-width: 0;
}

.smv-form .ant-form-item-control-input {
  min-height: 36px !important;
}

.smv-form .ant-select,
.smv-form .ant-input-number,
.smv-form .ant-input-number-affix-wrapper,
.smv-form .ant-input-number-group-wrapper,
.smv-form .ant-picker {
  width: 100% !important;
}

.smv-form .ant-select .ant-select-selector,
.smv-form .ant-input-number-affix-wrapper,
.smv-form .ant-input-number,
.smv-form .ant-picker {
  box-sizing: border-box;
  height: 36px !important;
  border-radius: 6px !important;
  border-color: #cbd5e1 !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 14px !important;
}

.smv-form .ant-input-number-affix-wrapper {
  display: inline-flex !important;
  align-items: center;
  padding: 0 12px !important;
  border: 1px solid #cbd5e1 !important;
}

.smv-form .ant-input-number-affix-wrapper .ant-input-number {
  flex: 1 1 auto;
  width: 100% !important;
  height: 34px !important;
  min-height: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.smv-form .ant-input-number-handler-wrap {
  display: none;
}

.smv-form .ant-select .ant-select-selection-item,
.smv-form .ant-select .ant-select-selection-placeholder,
.smv-form .ant-input-number-input,
.smv-form .ant-picker-input > input {
  line-height: 34px !important;
  height: 34px !important;
  font-size: 14px !important;
}

.smv-form .ant-input-number-input {
  padding: 0 !important;
}

.smv-form .ant-select .ant-select-selection-placeholder,
.smv-form .ant-picker-input > input::placeholder,
.smv-form .ant-input-number-input::placeholder {
  color: #94a3b8;
}

.smv-form .ant-select-focused .ant-select-selector,
.smv-form .ant-input-number-focused,
.smv-form .ant-input-number-affix-wrapper-focused,
.smv-form .ant-input-number-affix-wrapper:focus-within,
.smv-form .ant-picker-focused {
  border-color: #0ea5e9 !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;
}

.smv-form .ant-form-item-has-error .ant-select .ant-select-selector,
.smv-form .ant-form-item-has-error .ant-input-number-affix-wrapper,
.smv-form .ant-form-item-has-error .ant-input-number,
.smv-form .ant-form-item-has-error .ant-picker {
  border-color: #f43f5e !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/inventory/stockMovements/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;;;EAIE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,4BAA4B;EAC5B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;;;;EAIE,gCAAgC;AAClC","sourcesContent":[".smv-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  min-width: 0;\n}\n\n.smv-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.smv-form__label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.smv-form__req {\n  color: #ef4444;\n  font-weight: 600;\n}\n\n.smv-form__static {\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #f8fafc;\n  color: #0f172a;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.smv-form__hint {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.smv-form__hint.is-error {\n  color: #e11d48;\n}\n\n.smv-form .ant-form-item-label,\n.smv-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.smv-form .ant-form-item,\n.smv-form .ant-form-item-control-input,\n.smv-form .ant-form-item-control-input-content {\n  width: 100%;\n  min-width: 0;\n}\n\n.smv-form .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.smv-form .ant-select,\n.smv-form .ant-input-number,\n.smv-form .ant-input-number-affix-wrapper,\n.smv-form .ant-input-number-group-wrapper,\n.smv-form .ant-picker {\n  width: 100% !important;\n}\n\n.smv-form .ant-select .ant-select-selector,\n.smv-form .ant-input-number-affix-wrapper,\n.smv-form .ant-input-number,\n.smv-form .ant-picker {\n  box-sizing: border-box;\n  height: 36px !important;\n  border-radius: 6px !important;\n  border-color: #cbd5e1 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 14px !important;\n}\n\n.smv-form .ant-input-number-affix-wrapper {\n  display: inline-flex !important;\n  align-items: center;\n  padding: 0 12px !important;\n  border: 1px solid #cbd5e1 !important;\n}\n\n.smv-form .ant-input-number-affix-wrapper .ant-input-number {\n  flex: 1 1 auto;\n  width: 100% !important;\n  height: 34px !important;\n  min-height: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.smv-form .ant-input-number-handler-wrap {\n  display: none;\n}\n\n.smv-form .ant-select .ant-select-selection-item,\n.smv-form .ant-select .ant-select-selection-placeholder,\n.smv-form .ant-input-number-input,\n.smv-form .ant-picker-input > input {\n  line-height: 34px !important;\n  height: 34px !important;\n  font-size: 14px !important;\n}\n\n.smv-form .ant-input-number-input {\n  padding: 0 !important;\n}\n\n.smv-form .ant-select .ant-select-selection-placeholder,\n.smv-form .ant-picker-input > input::placeholder,\n.smv-form .ant-input-number-input::placeholder {\n  color: #94a3b8;\n}\n\n.smv-form .ant-select-focused .ant-select-selector,\n.smv-form .ant-input-number-focused,\n.smv-form .ant-input-number-affix-wrapper-focused,\n.smv-form .ant-input-number-affix-wrapper:focus-within,\n.smv-form .ant-picker-focused {\n  border-color: #0ea5e9 !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;\n}\n\n.smv-form .ant-form-item-has-error .ant-select .ant-select-selector,\n.smv-form .ant-form-item-has-error .ant-input-number-affix-wrapper,\n.smv-form .ant-form-item-has-error .ant-input-number,\n.smv-form .ant-form-item-has-error .ant-picker {\n  border-color: #f43f5e !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
